import React from "react";
import { FaEdit, FaTrash } from "react-icons/fa";
import { LoadingSpinner } from "../../components/LoadingSpinner";

// Loading Spinner Component

const StaffCard = ({ member, onEdit, onDelete, isDeleting }) => {
  const LoadingSpinner = ({ size = "w-6 h-6" }) => (
    <div
      className={`${size} animate-spin rounded-full border-2 border-blue-500 border-t-transparent`}
    ></div>
  );
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-all duration-300 p-6">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center text-white font-semibold text-lg">
            {(
              member.firstName?.[0] ||
              member.lastName?.[0] ||
              "S"
            ).toUpperCase()}
          </div>
          <div>
            <h3 className="font-semibold text-gray-900 text-lg">
              {member.firstName + " " + member.lastName}
            </h3>
            <span className="inline-block px-3 py-1 bg-blue-100 text-blue-700 text-sm rounded-full font-medium">
              {member.role}
            </span>
          </div>
        </div>
        <div className="flex space-x-2">
          <button
            onClick={() => onEdit(member.id)}
            className="p-2 text-gray-500 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
            disabled={isDeleting}
          >
            <FaEdit />
          </button>
          <button
            onClick={() => onDelete(member.id)}
            className="p-2 text-gray-500 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
            disabled={isDeleting}
          >
            {isDeleting ? <LoadingSpinner size="w-4 h-4" /> : <FaTrash />}
          </button>
        </div>
      </div>

      <div className="space-y-3 text-sm">
        <div className="flex items-center text-gray-600">
          <span className="font-medium w-20">Email:</span>
          <span className="text-gray-800">{member.email}</span>
        </div>
        <div className="flex items-center text-gray-600">
          <span className="font-medium w-20">Mobile:</span>
          <span className="text-gray-800">{member.mobileNo || "N/A"}</span>
        </div>
        <div className="flex items-start text-gray-600">
          <span className="font-medium w-20">Address:</span>
          <span className="text-gray-800 flex-1">{member.address}</span>
        </div>
        <div className="flex items-center text-gray-600">
          <span className="font-medium w-20">Store:</span>
          <span className="text-gray-800">{member.storeLocation}</span>
        </div>
        {member.pinCode && (
          <div className="flex items-center pt-2 mt-2 border-t border-gray-100">
            <span className="font-bold text-blue-700 w-auto mr-2">POS Login PIN:</span>
            <span className="bg-blue-50 text-blue-800 font-mono text-lg px-3 py-1 rounded-md tracking-wider border border-blue-200">
              {member.pinCode}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default StaffCard;
